module.exports = __webpack_public_path__ + "static/media/country.765b5ad8.svg";